import Vue from 'vue';
import cashbackCalc from './cashback-calc/cashback-calc.vue';
Vue.component('cashback-calc', cashbackCalc);
